import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

import type { ClassValue } from 'clsx';

export const twMerge = extendTailwindMerge({
    prefix: 'fun-',
});

// allows conditionally joining one or more tailwind classes
export const cn = (...args: ClassValue[]) => {
    return twMerge(clsx(args));
};
